module.exports = __webpack_public_path__ + "img/ACCOUNTING.960cbd2c.svg";